import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import footerBg from '../../assets/img/footer/footer-style1-bg.png';
import footerCtaBg from '../../assets/img/footer/footer-cta-bg.png';
import atsLogo from '../../assets/img/ATS-bg.png';
import instagram1 from '../../assets/img/instagram-post/instagram-1.png';
import instagram2 from '../../assets/img/instagram-post/instagram-2.png';
import instagram3 from '../../assets/img/instagram-post/instagram-3.png';
import instagram4 from '../../assets/img/instagram-post/instagram-4.png';
import instagram5 from '../../assets/img/instagram-post/instagram-5.png';
import instagram6 from '../../assets/img/instagram-post/instagram-6.png';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleNavigation = (path) => {
        navigate(path);
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 100);
    };

    const handleSubscribe = (e) => {
        e.preventDefault();
        console.log('Subscribed with:', email);
        setEmail('');
    };

    const instagramPosts = [instagram1, instagram2, instagram3, instagram4, instagram5, instagram6];

    return (
        <>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="scrollToTop scroll-btn"
                    style={{
                        position: 'fixed',
                        bottom: '30px',
                        right: '30px',
                        width: '60px',
                        height: '60px',
                        backgroundColor: '#f7921f',
                        color: '#fff',
                        border: '3px solid #fff',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                        transition: 'all 0.3s ease',
                        zIndex: 99999,
                        animation: 'fadeIn 0.3s ease',
                        opacity: 1,
                        visibility: 'visible',
                        outline: 'none'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e6831a';
                        e.target.style.transform = 'translateY(-3px) scale(1.1)';
                        e.target.style.boxShadow = '0 8px 25px rgba(247, 146, 31, 0.8)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f7921f';
                        e.target.style.transform = 'translateY(0) scale(1)';
                        e.target.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)';
                    }}
                >
                    <i className="fa-solid fa-arrow-up"></i>
                </button>
            )}

            <footer style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative'
            }}>
                <div style={{ padding: '80px 0 0 0' }}>
                    <div className="container">
                        <div style={{ marginBottom: '30px' }}>
                            <div style={{
                                background: `url(${footerCtaBg}) no-repeat center center, linear-gradient(135deg, #465b2d 0%, #5a7238 100%)`,
                                backgroundSize: 'cover',
                                borderRadius: '15px',
                                padding: '50px 40px',
                                position: 'relative',
                                overflow: 'hidden',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '20px'
                                }}>
                                    {/* Location - UPDATED FORMAT */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}>
                                        <div style={{
                                            width: '60px',
                                            height: '60px',
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: '24px',
                                            backdropFilter: 'blur(10px)'
                                        }}>
                                            <i className="fa-solid fa-location-dot"></i>
                                        </div>
                                        <div>
                                            <h5 style={{
                                                margin: '0 0 8px 0',
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                color: '#fff',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px'
                                            }}>
                                                Location
                                            </h5>
                                            <div style={{ color: '#fff', fontSize: '16px', fontWeight: '500' }}>
                                                <div style={{ marginBottom: '2px' }}>Smart Avenue unit F0-02, 4th Floor</div>
                                                <div style={{ marginBottom: '2px' }}>28/A 80 Feet Road, Michael Palya</div>
                                                <div>Indiranagar Bangalore - 560038</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contact Us */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}>
                                        <div style={{
                                            width: '60px',
                                            height: '60px',
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: '24px',
                                            backdropFilter: 'blur(10px)'
                                        }}>
                                            <i className="fa-solid fa-phone"></i>
                                        </div>
                                        <div>
                                            <h5 style={{
                                                margin: '0 0 8px 0',
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                color: '#fff',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px'
                                            }}>
                                                Contact Us
                                            </h5>
                                            <div style={{ margin: 0, color: '#fff' }}>
                                                <a href="mailto:Booking@ascendtravelsolutions.in" style={{
                                                    color: '#fff',
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    marginBottom: '4px',
                                                    transition: 'color 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.color = '#f7921f'}
                                                    onMouseLeave={(e) => e.target.style.color = '#fff'}>
                                                    Booking@ascendtravelsolutions.in
                                                </a>
                                                <a href="tel:8317447895" style={{
                                                    color: '#fff',
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    transition: 'color 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.color = '#f7921f'}
                                                    onMouseLeave={(e) => e.target.style.color = '#fff'}>
                                                    83174 47895
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Link
                                            to="/book/south-india-korea"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                navigate('/book/south-india-korea');
                                            }}
                                            style={{
                                                display: 'inline-block',
                                                backgroundColor: '#f7921f',
                                                color: '#fff',
                                                padding: '18px 35px',
                                                borderRadius: '50px',
                                                textDecoration: 'none',
                                                fontWeight: '700',
                                                textTransform: 'uppercase',
                                                letterSpacing: '2px',
                                                transition: 'all 0.3s ease',
                                                border: '2px solid #f7921f',
                                                fontSize: '16px',
                                                boxShadow: '0 5px 15px rgba(247, 146, 31, 0.3)',
                                                whiteSpace: 'nowrap'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateY(-3px)';
                                                e.target.style.boxShadow = '0 8px 25px rgba(247, 146, 31, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#f7921f';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = '0 5px 15px rgba(247, 146, 31, 0.3)';
                                            }}
                                        >
                                            BOOKING NOW
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div style={{ padding: '80px 0 60px' }}>
                    <div className="container">
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: '40px',
                            alignItems: 'start'
                        }}>

                            <div>
                                <Link to="/" onClick={() => handleNavigation('/')} style={{ display: 'block', marginBottom: '25px' }}>
                                    <img
                                        src={atsLogo}
                                        alt="Ascend Travel Solutions"
                                        style={{
                                            maxHeight: '120px',
                                            width: 'auto'
                                        }}
                                    />
                                </Link>

                                <div style={{ marginBottom: '25px' }}>
                                    <ul style={{
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0,
                                        display: 'flex',
                                        gap: '12px'
                                    }}>
                                        {['facebook-f', 'x-twitter', 'instagram', 'youtube'].map((platform) => (
                                            <li key={platform}>
                                                <a
                                                    href={`https://www.${platform === 'x-twitter' ? 'x.com' : platform + '.com'}/`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        width: '45px',
                                                        height: '45px',
                                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#fff',
                                                        textDecoration: 'none',
                                                        transition: 'all 0.3s ease',
                                                        fontSize: '18px'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#f7921f';
                                                        e.target.style.transform = 'translateY(-3px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    <i className={`fa-brands fa-${platform}`}></i>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    marginBottom: '25px',
                                    fontSize: '16px',
                                    lineHeight: '1.6'
                                }}>
                                    Stay connected for future updates.
                                </p>

                                <form onSubmit={handleSubscribe} style={{ position: 'relative' }}>
                                    <input
                                        type="email"
                                        placeholder="Enter Email Address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '15px 20px',
                                            borderRadius: '50px',
                                            border: '2px solid rgba(255,255,255,0.2)',
                                            backgroundColor: 'rgba(255,255,255,0.1)',
                                            color: '#fff',
                                            outline: 'none',
                                            fontSize: '14px'
                                        }}
                                    />
                                    <button
                                        type="submit"
                                        style={{
                                            position: 'absolute',
                                            right: '5px',
                                            top: '5px',
                                            backgroundColor: '#f7921f',
                                            border: 'none',
                                            borderRadius: '50px',
                                            padding: '19px',
                                            color: '#fff',
                                            textTransform: 'uppercase',
                                            fontSize: '12px',
                                            fontWeight: '700',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#e6831a';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#f7921f';
                                        }}
                                    >
                                        <span>Subscribe now</span>
                                        <i className="fa-solid fa-angles-right"></i>
                                    </button>
                                </form>
                            </div>

                            {/* Useful Links */}
                            <div>
                                <h5 style={{
                                    color: '#fff',
                                    fontSize: '22px',
                                    fontWeight: '700',
                                    marginBottom: '25px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px'
                                }}>
                                    Useful Links
                                </h5>

                                {/* Separator Line */}
                                <div style={{
                                    height: '2px',
                                    background: 'linear-gradient(90deg, #f7921f 0%, transparent 100%)',
                                    marginBottom: '25px',
                                    width: '60px'
                                }}></div>

                                <ul style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0
                                }}>
                                    {[
                                        { path: '/enquiry', text: 'Help Center' },
                                        { path: '/about', text: 'About Us' },
                                        { path: '/contact', text: 'Contact Us' },
                                        { path: '/blog', text: 'Blog' },
                                    ].map((link, index) => (
                                        <li key={index} style={{ marginBottom: '12px' }}>
                                            <button
                                                onClick={() => handleNavigation(link.path)}
                                                style={{
                                                    color: 'rgba(255,255,255,0.8)',
                                                    textDecoration: 'none',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    transition: 'all 0.3s ease',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    padding: '0',
                                                    textAlign: 'left',
                                                    width: '100%'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.color = '#f7921f';
                                                    e.target.style.transform = 'translateX(5px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.color = 'rgba(255,255,255,0.8)';
                                                    e.target.style.transform = 'translateX(0)';
                                                }}
                                            >
                                                <i className="fa-solid fa-angles-right" style={{
                                                    fontSize: '12px',
                                                    color: '#f7921f'
                                                }}></i>
                                                {link.text}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Instagram */}
                            <div>
                                <h5 style={{
                                    color: '#fff',
                                    fontSize: '22px',
                                    fontWeight: '700',
                                    marginBottom: '25px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px'
                                }}>
                                    Instagram
                                </h5>


                                <div style={{
                                    height: '2px',
                                    background: 'linear-gradient(90deg, #f7921f 0%, transparent 100%)',
                                    marginBottom: '25px',
                                    width: '60px'
                                }}></div>

                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    marginBottom: '20px',
                                    fontSize: '16px',
                                    lineHeight: '1.6'
                                }}>
                                    Follow us on Instagram for the latest travel inspiration, behind-the-scenes moments, and exclusive offers from Ascend Travel Solutions.
                                </p>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: '8px',
                                    marginBottom: '20px'
                                }}>
                                    {instagramPosts.map((post, index) => (
                                        <a
                                            key={index}
                                            href="https://www.instagram.com/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                display: 'block',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                transition: 'transform 0.3s ease',
                                                position: 'relative'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <img
                                                src={post}
                                                alt={`Instagram post ${index + 1}`}
                                                style={{
                                                    width: '100%',
                                                    height: '80px',
                                                    objectFit: 'cover',
                                                    display: 'block'
                                                }}
                                            />
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                backgroundColor: 'rgba(247, 146, 31, 0.8)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                opacity: 0,
                                                transition: 'opacity 0.3s ease'
                                            }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.opacity = '1';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.opacity = '0';
                                                }}
                                            >
                                                <i className="fa-brands fa-instagram" style={{
                                                    color: '#fff',
                                                    fontSize: '20px'
                                                }}></i>
                                            </div>
                                        </a>
                                    ))}
                                </div>

                                <a
                                    href="https://www.instagram.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        color: '#f7921f',
                                        textDecoration: 'none',
                                        fontWeight: '600',
                                        fontSize: '16px',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.color = '#fff';
                                        e.target.style.transform = 'translateX(5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.color = '#f7921f';
                                        e.target.style.transform = 'translateX(0)';
                                    }}
                                >
                                    <span>Follow @ascendtravel</span>
                                    <i className="fa-solid fa-arrow-up-right-from-square" style={{ fontSize: '12px' }}></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                <div style={{
                    backgroundColor: 'rgba(15, 44, 14, 0.3)',
                    padding: '25px 0',
                    borderTop: '1px solid rgba(255,255,255,0.1)'
                }}>
                    <div className="container">
                        <div style={{ textAlign: 'center' }}>
                            <p style={{
                                margin: 0,
                                color: 'rgba(255,255,255,0.7)',
                                fontSize: '14px'
                            }}>
                                © {currentYear}{' '}
                                <button
                                    onClick={() => handleNavigation('/')}
                                    style={{
                                        color: '#f7921f',
                                        textDecoration: 'none',
                                        fontWeight: '600',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: '14px'
                                    }}
                                >
                                    Website Designed & maintained By
                                    Veriteam Software
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>


            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .scrollToTop {
                    animation: fadeIn 0.3s ease;
                }
            `}</style>

            <style>{`
                .scroll-btn {
                    z-index: 99999 !important;
                    position: fixed !important;
                    bottom: 30px !important;
                    right: 30px !important;
                    width: 60px !important;
                    height: 60px !important;
                    background-color: #f7921f !important;
                    color: white !important;
                    border: 3px solid white !important;
                    border-radius: 50% !important;
                    cursor: pointer !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    font-size: 20px !important;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.3) !important;
                    transition: all 0.3s ease !important;
                    opacity: 1 !important;
                    visibility: visible !important;
                    outline: none !important;
                }

                .scroll-btn:hover {
                    background-color: #e6831a !important;
                    transform: translateY(-3px) scale(1.1) !important;
                    box-shadow: 0 8px 25px rgba(247, 146, 31, 0.8) !important;
                }
            `}</style>
        </>
    );
};

export default Footer;